import React from "react";
import $ from "jquery";
import Button from "components/CustomButtons/Button.jsx";
import { connect } from "react-redux";
import "assets/scss/responsive.css";
import "./customstyle.css";
import Result from "./SegmentQueryBuilder/Result";
import GroupModal from "./SegmentQueryBuilder/Modal";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import PieChart from "./PieChart";
class Segment extends React.Component {
  constructor(props) {
    super(props);
    this.handler();
  }
  handler = () => {
  };
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  render() {
    let partial = "";
    this.props.dispatch({
      type: "REMOVE_SEGMENT_NAME"
    });
    let segmentNameTemp = this.props.segmentName;
    let segmentDataTemp = this.props.segmentData;
    let showSpinnerChart = "";
    let chartView = "";
    let displaySpinner = "";
    if (this.props.showQuerySpinnerSegment === "yes") {
      displaySpinner = 'show';
      showSpinnerChart = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
      );
    } else if (segmentNameTemp.length > 0 && ((this.props.queryCount["query_count"] == "" || this.props.queryCount["query_count"] == " ") || this.props.queryCountTempSegment["query_count"] == "" || this.props.queryCountTempSegment["query_count"] == " ")) {
      displaySpinner = 'show';
      showSpinnerChart = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
      );
    } else {
      if (segmentNameTemp.length > 0) {
        showSpinnerChart = this.numberWithCommas(this.props.queryCount["query_count"]);
        displaySpinner = 'hide';
        let queryCount = 0;
        if (this.props.queryCount["query_count"] != "" && this.props.queryCount["query_count"] != " ") {
          queryCount = this.props.queryCount["query_count"]
        } else {
          queryCount = this.props.queryCountTempSegment["query_count"]
        }
        chartView = (<PieChart segmentsName={segmentNameTemp} segmentsData={segmentDataTemp} filteredAudience={queryCount} />)
      }
    }

    return (
      <GridContainer style={{marginBottom: "0px"}}>
        <GridItem xs={8} sm={8} md={8}>
          <Card
            style={{
              textAlign: "left",
              marginBottom: "0px"
            }}
          >
            <div className="filtercentercontent summarycontent">
              <div
                className="filteraudiencetitle summarytitle"
                style={{ minHeight: "40px" }}
              >
                <h2 className="capitalize">Segment Criteria</h2>
                <a href="javascript:void(0)" style={{ float: "right" }}>
                  <GroupModal
                    buttonLabel="Add Filter"
                    selectedIndex="no_index"
                    selectedRule=""
                    mode="Create"
                    type="group"
                    buttonType="add group"
                    class="withoutbgbtn"
                    style={{ marginRight: "0px" }}
                  />
                </a>
              </div>
              <CardBody
                style={{
                  textAlign: "left",
                  // overflowY: "auto",
                  minHeight: "370px",
                  marginBottom: "0px"
                }}
              >
                <div className="filtercentercontent">
                  <div className="">
                    {/* <div class="btngroup">
                    <a href="javascript:void(0)" class="btn">
                      <i class="plussign" />
                      add group
                    </a>
                  </div> */}
                    <Result onButton="" />
                  </div>
                </div>
             </CardBody>
             </div>
           </Card>
         </GridItem>
         <GridItem xs={4} sm={4} md={4}>
           <Card
            style={{
              marginBottom: "0px"
            }}
            >
             <div className="filtercentercontent summarycontent">
               <div className="filteraudiencetitle summarytitle" style={{minHeight: '40px'}}>
                  <h2 className="capitalize">Summary</h2>
                </div>
                 <CardBody
                   style={{
                     height: "370px",
                     textAlign: "center",
                     marginBottom: "0px"
                   }}
                 >
                 {displaySpinner === "show" ? showSpinnerChart : displaySpinner === "hide" ? chartView : ""}
               </CardBody>
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = state => ({
  count: state.count,
  tillSqlSelectionArr: state.tillSqlSelectionArr,
  afterSqlSelectionArr: state.afterSqlSelectionArr,
  ruleLeveltoggle: state.ruleLeveltoggle,
  groupLeveltoggle: state.groupLeveltoggle,
  title: state.title,
  listDescription: state.listDescription,
  queryCount: state.queryCount,
  showQuerySpinner: state.showQuerySpinner,
  showQuerySpinnerSegment: state.showQuerySpinnerSegment,
  segmentData: state.segmentData,
  segmentName: state.segmentName,
  queryCountTempSegment: state.queryCountTempSegment,
});
export default connect(mapStateToProps)(Segment);



// WEBPACK FOOTER //
// ./src/views/Audiences/Segment.jsx